import type { MeterBarChartLegendProps } from '../../shared/types/meter-bar-legend.js';

/**
 * Props for the MultiMeterBarChart.Legend slot component
 * @public
 */
export type MultiMeterBarChartLegendProps = MeterBarChartLegendProps;

export const Legend = (_props: MultiMeterBarChartLegendProps) => null;

Legend['displayName'] = 'MultiMeterBarChart.Legend';
